import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "store"
import type { ILicensePool } from "types/licensePoolTypes"

interface LicensePoolState {
  licensePools: Array<ILicensePool>
  currentLicensePool: ILicensePool | undefined
}

const initialState: LicensePoolState = {
  licensePools: [] as ILicensePool[],
  currentLicensePool: undefined,
}

export const licensePoolSlice = createSlice({
  name: "licensePool",
  initialState,
  reducers: {
    setLicensePools: (state, action: PayloadAction<Array<ILicensePool>>) => {
      state.licensePools = action.payload
    },
    setCurrentLicensePool: (state, action: PayloadAction<ILicensePool | undefined>) => {
      state.currentLicensePool = action.payload
    },
    addLicensePool: (state, action: PayloadAction<ILicensePool>) => {
      state.licensePools = state.licensePools.concat(action.payload)
    },
    updateLicensePool: (state, action: PayloadAction<ILicensePool>) => {
      var index = state.licensePools.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.licensePools[index] = action.payload
      }
    },
    removeLicensePool: (state, action: PayloadAction<ILicensePool>) => {
      var index = state.licensePools.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.licensePools.splice(index, 1)
      }
    },
    resetLicensePool: (state, _action) => {
      state.licensePools = []
      state.currentLicensePool = undefined
    },
  },
})

export const {
  setLicensePools,
  addLicensePool,
  updateLicensePool,
  removeLicensePool,
  setCurrentLicensePool,
  resetLicensePool,
} = licensePoolSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectCount = (state: RootState) => state.licensepool

export default licensePoolSlice.reducer
